import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const LandingPageBenefits = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12726"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12726)">
          <rect
            x="-2"
            y="-2"
            width="123"
            height="114"
            rx="5.58065"
            fill="#FFEDBF"
          />
          <path
            d="M95.7418 35.4412V86.35C95.7418 88.0378 95.0713 89.6564 93.8779 90.8498C92.6845 92.0432 91.0659 92.7136 89.3782 92.7136H28.9239C27.2362 92.7136 25.6176 92.0432 24.4242 90.8498C23.2308 89.6564 22.5603 88.0378 22.5603 86.35V35.4412H95.7418Z"
            fill="#66E1FF"
          />
          <path
            d="M22.5603 35.4412V86.35C22.5603 88.0378 23.2308 89.6564 24.4242 90.8498C25.6176 92.0432 27.2362 92.7136 28.9239 92.7136H32.1057L89.3782 35.4412H22.5603Z"
            fill="#C2F3FF"
          />
          <path
            d="M95.7418 35.441H22.5603V25.8956C22.5603 24.2079 23.2308 22.5892 24.4242 21.3958C25.6176 20.2024 27.2362 19.532 28.9239 19.532H89.3782C91.0659 19.532 92.6845 20.2024 93.8779 21.3958C95.0713 22.5892 95.7418 24.2079 95.7418 25.8956V35.441Z"
            fill="white"
          />
          <path
            d="M89.3782 19.532H28.9239C27.2362 19.532 25.6176 20.2024 24.4242 21.3958C23.2308 22.5892 22.5603 24.2079 22.5603 25.8956V86.3499C22.5603 88.0376 23.2308 89.6562 24.4242 90.8496C25.6176 92.043 27.2362 92.7135 28.9239 92.7135H89.3782C91.0659 92.7135 92.6845 92.043 93.8779 90.8496C95.0713 89.6562 95.7418 88.0376 95.7418 86.3499V25.8956C95.7418 24.2079 95.0713 22.5892 93.8779 21.3958C92.6845 20.2024 91.0659 19.532 89.3782 19.532Z"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.5603 35.4412H95.7418"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.6966 28.2822C33.4856 28.2822 33.2833 28.1984 33.1341 28.0492C32.9849 27.9 32.9011 27.6977 32.9011 27.4867C32.9011 27.2758 32.9849 27.0734 33.1341 26.9243C33.2833 26.7751 33.4856 26.6913 33.6966 26.6913"
            stroke="#191919"
            strokeWidth="1.04637"
          />
          <path
            d="M33.6968 28.2822C33.9077 28.2822 34.1101 28.1984 34.2592 28.0492C34.4084 27.9 34.4922 27.6977 34.4922 27.4867C34.4922 27.2758 34.4084 27.0734 34.2592 26.9243C34.1101 26.7751 33.9077 26.6913 33.6968 26.6913"
            stroke="#191919"
            strokeWidth="1.04637"
          />
          <path
            d="M43.242 28.2822C43.031 28.2822 42.8287 28.1984 42.6795 28.0492C42.5303 27.9 42.4465 27.6977 42.4465 27.4867C42.4465 27.2758 42.5303 27.0734 42.6795 26.9243C42.8287 26.7751 43.031 26.6913 43.242 26.6913"
            stroke="#191919"
            strokeWidth="1.04637"
          />
          <path
            d="M43.2422 28.2822C43.4532 28.2822 43.6555 28.1984 43.8047 28.0492C43.9538 27.9 44.0376 27.6977 44.0376 27.4867C44.0376 27.2758 43.9538 27.0734 43.8047 26.9243C43.6555 26.7751 43.4532 26.6913 43.2422 26.6913"
            stroke="#191919"
            strokeWidth="1.04637"
          />
          <path
            d="M52.7874 28.2822C52.5764 28.2822 52.3741 28.1984 52.2249 28.0492C52.0758 27.9 51.9919 27.6977 51.9919 27.4867C51.9919 27.2758 52.0758 27.0734 52.2249 26.9243C52.3741 26.7751 52.5764 26.6913 52.7874 26.6913"
            stroke="#191919"
            strokeWidth="1.04637"
          />
          <path
            d="M52.7874 28.2823C52.9983 28.2823 53.2006 28.1985 53.3498 28.0493C53.499 27.9002 53.5828 27.6978 53.5828 27.4869C53.5828 27.2759 53.499 27.0736 53.3498 26.9244C53.2006 26.7752 52.9983 26.6914 52.7874 26.6914"
            stroke="#191919"
            strokeWidth="1.04637"
          />
          <path
            d="M40.181 41.588L41.6699 45.042H44.5666C44.7129 45.0362 44.8575 45.0758 44.9805 45.1554C45.1035 45.2349 45.199 45.3505 45.2538 45.4863C45.3087 45.6221 45.3202 45.7716 45.2869 45.9142C45.2536 46.0569 45.1771 46.1858 45.0677 46.2833L42.5523 48.524L43.9454 51.7292C44.0066 51.8758 44.0202 52.0379 43.9844 52.1927C43.9486 52.3474 43.8652 52.4871 43.7459 52.592C43.6266 52.6968 43.4775 52.7617 43.3194 52.7774C43.1613 52.793 43.0023 52.7587 42.8648 52.6793L39.5037 50.7821L36.1369 52.6841C35.9993 52.7636 35.8403 52.7979 35.6822 52.7822C35.5242 52.7665 35.375 52.7017 35.2557 52.5968C35.1364 52.4919 35.053 52.3523 35.0172 52.1975C34.9814 52.0428 34.995 51.8807 35.0562 51.7341L36.4465 48.524L33.931 46.2833C33.8208 46.1865 33.7434 46.0579 33.7093 45.9153C33.6753 45.7726 33.6863 45.6229 33.7408 45.4868C33.7953 45.3507 33.8907 45.2348 34.0139 45.1551C34.137 45.0755 34.2818 45.0359 34.4283 45.042H37.3307L38.8216 41.588C38.8879 41.4649 38.9862 41.3621 39.1062 41.2904C39.2262 41.2187 39.3634 41.1808 39.5032 41.1808C39.643 41.1808 39.7802 41.2187 39.9002 41.2904C40.0202 41.3621 40.1186 41.4649 40.1848 41.588H40.181Z"
            fill="#FFEF5E"
          />
          <path
            d="M41.6699 45.0409L40.1809 41.5869C40.1147 41.4638 40.0164 41.361 39.8963 41.2893C39.7763 41.2176 39.6391 41.1797 39.4993 41.1797C39.3595 41.1797 39.2224 41.2176 39.1024 41.2893C38.9823 41.361 38.884 41.4638 38.8178 41.5869L37.3269 45.0409H34.4244C34.2784 45.036 34.1344 45.0762 34.012 45.156C33.8896 45.2359 33.7948 45.3515 33.7405 45.4871C33.6861 45.6228 33.6749 45.7719 33.7083 45.9141C33.7417 46.0564 33.8181 46.1849 33.9271 46.2822L36.4426 48.5229L35.0562 51.7291C34.9873 51.9005 34.9838 52.0913 35.0465 52.2651L42.2697 45.0409H41.6699Z"
            fill="#FFF9BF"
          />
          <path
            d="M40.181 41.588L41.6699 45.042H44.5666C44.7129 45.0362 44.8575 45.0758 44.9805 45.1554C45.1035 45.2349 45.199 45.3505 45.2538 45.4863C45.3087 45.6221 45.3202 45.7716 45.2869 45.9142C45.2536 46.0569 45.1771 46.1858 45.0677 46.2833L42.5523 48.524L43.9454 51.7292C44.0066 51.8758 44.0202 52.0379 43.9844 52.1927C43.9486 52.3474 43.8652 52.4871 43.7459 52.592C43.6266 52.6968 43.4775 52.7617 43.3194 52.7774C43.1613 52.793 43.0023 52.7587 42.8648 52.6793L39.5037 50.7821L36.1369 52.6841C35.9993 52.7636 35.8403 52.7979 35.6822 52.7822C35.5242 52.7665 35.375 52.7017 35.2557 52.5968C35.1364 52.4919 35.053 52.3523 35.0172 52.1975C34.9814 52.0428 34.995 51.8807 35.0562 51.7341L36.4465 48.524L33.931 46.2833C33.8208 46.1865 33.7434 46.0579 33.7093 45.9153C33.6753 45.7726 33.6863 45.6229 33.7408 45.4868C33.7953 45.3507 33.8907 45.2348 34.0139 45.1551C34.137 45.0755 34.2818 45.0359 34.4283 45.042H37.3307L38.8216 41.588C38.8879 41.4649 38.9862 41.3621 39.1062 41.2904C39.2262 41.2187 39.3634 41.1808 39.5032 41.1808C39.643 41.1808 39.7802 41.2187 39.9002 41.2904C40.0202 41.3621 40.1186 41.4649 40.1848 41.588H40.181Z"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.0271 44.6102H84.6127"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.0271 49.355H77.6789"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.1812 57.3555L41.6702 60.8094H44.5668C44.7132 60.8037 44.8578 60.8433 44.9808 60.9228C45.1038 61.0024 45.1992 61.1179 45.2541 61.2538C45.3089 61.3896 45.3205 61.5391 45.2872 61.6817C45.2539 61.8243 45.1773 61.9532 45.068 62.0507L42.5525 64.2914L43.9457 67.4967C44.0068 67.6433 44.0205 67.8054 43.9847 67.9601C43.9489 68.1149 43.8655 68.2545 43.7462 68.3594C43.6269 68.4643 43.4777 68.5291 43.3196 68.5448C43.1616 68.5605 43.0026 68.5262 42.865 68.4468L39.504 66.5495L36.1371 68.4516C35.9995 68.531 35.8405 68.5653 35.6825 68.5496C35.5244 68.534 35.3752 68.4691 35.2559 68.3643C35.1366 68.2594 35.0532 68.1197 35.0174 67.965C34.9816 67.8102 34.9953 67.6481 35.0564 67.5015L36.4467 64.2914L33.9312 62.0507C33.8211 61.9539 33.7436 61.8253 33.7096 61.6827C33.6755 61.5401 33.6865 61.3904 33.741 61.2543C33.7956 61.1181 33.891 61.0023 34.0141 60.9226C34.1372 60.8429 34.282 60.8034 34.4285 60.8094H37.331L38.8219 57.3555C38.8881 57.2324 38.9865 57.1295 39.1065 57.0578C39.2265 56.9861 39.3637 56.9482 39.5035 56.9482C39.6433 56.9482 39.7805 56.9861 39.9005 57.0578C40.0205 57.1295 40.1188 57.2324 40.1851 57.3555H40.1812Z"
            fill="#FFEF5E"
          />
          <path
            d="M41.6699 60.8081L40.1809 57.3542C40.1147 57.2311 40.0164 57.1282 39.8963 57.0565C39.7763 56.9848 39.6391 56.9469 39.4993 56.9469C39.3595 56.9469 39.2224 56.9848 39.1024 57.0565C38.9823 57.1282 38.884 57.2311 38.8178 57.3542L37.3269 60.8081H34.4244C34.2784 60.8032 34.1344 60.8434 34.012 60.9232C33.8896 61.0031 33.7948 61.1187 33.7405 61.2543C33.6861 61.39 33.6749 61.5391 33.7083 61.6813C33.7417 61.8236 33.8181 61.9521 33.9271 62.0494L36.4426 64.2901L35.0562 67.4963C34.9873 67.6677 34.9838 67.8585 35.0465 68.0323L42.2697 60.8081H41.6699Z"
            fill="#FFF9BF"
          />
          <path
            d="M40.1812 57.3555L41.6702 60.8094H44.5668C44.7132 60.8037 44.8578 60.8433 44.9808 60.9228C45.1038 61.0024 45.1992 61.1179 45.2541 61.2538C45.3089 61.3896 45.3205 61.5391 45.2872 61.6817C45.2539 61.8243 45.1773 61.9532 45.068 62.0507L42.5525 64.2914L43.9457 67.4967C44.0068 67.6433 44.0205 67.8054 43.9847 67.9601C43.9489 68.1149 43.8655 68.2545 43.7462 68.3594C43.6269 68.4643 43.4777 68.5291 43.3196 68.5448C43.1616 68.5605 43.0026 68.5262 42.865 68.4468L39.504 66.5495L36.1371 68.4516C35.9995 68.531 35.8405 68.5653 35.6825 68.5496C35.5244 68.534 35.3752 68.4691 35.2559 68.3643C35.1366 68.2594 35.0532 68.1197 35.0174 67.965C34.9816 67.8102 34.9953 67.6481 35.0564 67.5015L36.4467 64.2914L33.9312 62.0507C33.8211 61.9539 33.7436 61.8253 33.7096 61.6827C33.6755 61.5401 33.6865 61.3904 33.741 61.2543C33.7956 61.1181 33.891 61.0023 34.0141 60.9226C34.1372 60.8429 34.282 60.8034 34.4285 60.8094H37.331L38.8219 57.3555C38.8881 57.2324 38.9865 57.1295 39.1065 57.0578C39.2265 56.9861 39.3637 56.9482 39.5035 56.9482C39.6433 56.9482 39.7805 56.9861 39.9005 57.0578C40.0205 57.1295 40.1188 57.2324 40.1851 57.3555H40.1812Z"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.0271 60.3773H72.7539"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.0271 65.1223H81.8644"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.1812 73.1231L41.6702 76.577H44.5668C44.7132 76.5713 44.8578 76.6109 44.9808 76.6904C45.1038 76.7699 45.1992 76.8855 45.2541 77.0213C45.3089 77.1572 45.3205 77.3066 45.2872 77.4493C45.2539 77.5919 45.1773 77.7208 45.068 77.8183L42.5525 80.059L43.9457 83.2643C44.0068 83.4109 44.0205 83.573 43.9847 83.7277C43.9489 83.8825 43.8655 84.0221 43.7462 84.127C43.6269 84.2319 43.4777 84.2967 43.3196 84.3124C43.1616 84.3281 43.0026 84.2938 42.865 84.2143L39.504 82.3171L36.1371 84.2192C35.9995 84.2986 35.8405 84.3329 35.6825 84.3172C35.5244 84.3016 35.3752 84.2367 35.2559 84.1318C35.1366 84.027 35.0532 83.8873 35.0174 83.7326C34.9816 83.5778 34.9953 83.4157 35.0564 83.2691L36.4467 80.059L33.9312 77.8183C33.8211 77.7215 33.7436 77.5929 33.7096 77.4503C33.6755 77.3077 33.6865 77.158 33.741 77.0218C33.7956 76.8857 33.891 76.7698 34.0141 76.6902C34.1372 76.6105 34.282 76.571 34.4285 76.577H37.331L38.8219 73.1231C38.8881 73 38.9865 72.8971 39.1065 72.8254C39.2265 72.7537 39.3637 72.7158 39.5035 72.7158C39.6433 72.7158 39.7805 72.7537 39.9005 72.8254C40.0205 72.8971 40.1188 73 40.1851 73.1231H40.1812Z"
            fill="#FFEF5E"
          />
          <path
            d="M41.6699 76.5758L40.1809 73.1219C40.1147 72.9988 40.0164 72.8959 39.8963 72.8242C39.7763 72.7525 39.6391 72.7146 39.4993 72.7146C39.3595 72.7146 39.2224 72.7525 39.1024 72.8242C38.9823 72.8959 38.884 72.9988 38.8178 73.1219L37.3269 76.5758H34.4244C34.2784 76.5709 34.1344 76.6111 34.012 76.6909C33.8896 76.7708 33.7948 76.8864 33.7405 77.022C33.6861 77.1577 33.6749 77.3068 33.7083 77.449C33.7417 77.5913 33.8181 77.7198 33.9271 77.8171L36.4426 80.0578L35.0562 83.264C34.9873 83.4354 34.9838 83.6262 35.0465 83.8L42.2697 76.5758H41.6699Z"
            fill="#FFF9BF"
          />
          <path
            d="M40.1812 73.1231L41.6702 76.577H44.5668C44.7132 76.5713 44.8578 76.6109 44.9808 76.6904C45.1038 76.7699 45.1992 76.8855 45.2541 77.0213C45.3089 77.1572 45.3205 77.3066 45.2872 77.4493C45.2539 77.5919 45.1773 77.7208 45.068 77.8183L42.5525 80.059L43.9457 83.2643C44.0068 83.4109 44.0205 83.573 43.9847 83.7277C43.9489 83.8825 43.8655 84.0221 43.7462 84.127C43.6269 84.2319 43.4777 84.2967 43.3196 84.3124C43.1616 84.3281 43.0026 84.2938 42.865 84.2143L39.504 82.3171L36.1371 84.2192C35.9995 84.2986 35.8405 84.3329 35.6825 84.3172C35.5244 84.3016 35.3752 84.2367 35.2559 84.1318C35.1366 84.027 35.0532 83.8873 35.0174 83.7326C34.9816 83.5778 34.9953 83.4157 35.0564 83.2691L36.4467 80.059L33.9312 77.8183C33.8211 77.7215 33.7436 77.5929 33.7096 77.4503C33.6755 77.3077 33.6865 77.158 33.741 77.0218C33.7956 76.8857 33.891 76.7698 34.0141 76.6902C34.1372 76.6105 34.282 76.571 34.4285 76.577H37.331L38.8219 73.1231C38.8881 73 38.9865 72.8971 39.1065 72.8254C39.2265 72.7537 39.3637 72.7158 39.5035 72.7158C39.6433 72.7158 39.7805 72.7537 39.9005 72.8254C40.0205 72.8971 40.1188 73 40.1851 73.1231H40.1812Z"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.0271 76.1451H78.2403"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.0271 80.8904H73.3421"
            stroke="#191919"
            strokeWidth="1.04637"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
LandingPageBenefits.displayName = 'LandingPageBenefits';
